import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getOperatorPresence = async (queries) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/attendance?${queries}` });

  return data;
};

export default getOperatorPresence;
